import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const FinishedRegister = () => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center w-full min-h-screen p-4">
            <div className="w-full max-w-[420px] p-4 mx-auto bg-grey-light text-center">
                <p className="text-blue  w-full text-center p-2 mb-4">{t('users.registration.FINISH_INFO')}</p>

                <Link
                    className="text-xs font-semibold bg-blue py-2 px-3.5 text-white mt-4 block m-auto w-[30%]"
                    to="/login"
                >
                    {t('users.registration.LOGIN_BUTTON')}
                </Link>
            </div>
        </div>
    );
};

export default FinishedRegister;
